import { SimpleGrid, Title, Stack } from '@mantine/core';
import { CompanyStats } from './CompanyStats';
import { RevenueChart } from './RevenueChart';

export function DashboardPage() {
  return (
    <Stack gap="lg">
      <Title order={2}>Dashboard</Title>
      <CompanyStats />
      <RevenueChart />
    </Stack>
  );
}
